(function () {
  let prodcarousel = () => {
    $(".product-carousel-section").each(function () {
      let slideEl = $(this).find(".product-carousel__wrapper");
      let carousel = $(this).find(".swiper-carousel");
      let slide = $(this).find(".swiper-slide");
      let buttonNext = $(this).find(".swiper-button-next");
      let prodCountHalf = parseFloat(slideEl.data("count")) + 0.1;

      if ($(this).hasClass("slider_started")) {
        return "";
      }
      $(this).addClass("slider_started");

      let id = $(this).attr("id");
      let prodSwiperParams = {
        centeredSlides: false,
        slidesPerView: 1.25, // Show 1 full slide + 25% of next slide on mobile
        waitForTransition: false,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        preloadImages: true,
        allowTouchMove: true,
        spaceBetween: 15, // Increased spacing between slides
        breakpoints: {
          990: {
            slidesPerView: 2.1,
          },
          1200: {
            slidesPerView: 3.1,
          },
          1360: {
            slidesPerView: prodCountHalf,
          },
        },
        on: {
          slideChange: function () {
            if (window.innerWidth <= 989) {
              // Mobile behavior
              const isFirstSlide = this.isBeginning;
              const isLastSlide = this.isEnd;
              const wrapper = this.el.querySelector(".swiper-wrapper");

              if (isFirstSlide) {
                // First slide - left aligned
                wrapper.style.transform = "translate3d(0px, 0px, 0px)";
                Array.from(carousel).forEach((element) => {
                  element.classList.add("carousel_change-postion_next");
                  element.classList.remove("carousel_change-postion_prev");
                  element.classList.remove("carousel_change-postion_next-2");
                });
              } else if (isLastSlide) {
                // Last slide - right aligned
                const containerWidth = this.el.offsetWidth;
                const slideWidth = this.slides[0].offsetWidth;
                const totalSlides = this.slides.length;
                const offset =
                  containerWidth -
                  slideWidth * totalSlides -
                  this.params.spaceBetween * (totalSlides - 1);
                wrapper.style.transform = `translate3d(${offset}px, 0px, 0px)`;
                Array.from(carousel).forEach((element) => {
                  element.classList.remove("carousel_change-postion_next");
                  element.classList.add("carousel_change-postion_prev");
                });
              } else {
                // Middle slides - centered with peek on both sides
                const containerWidth = this.el.offsetWidth;
                const slideWidth = this.slides[0].offsetWidth;
                const activeSlideIndex = this.activeIndex;
                const centerOffset = (containerWidth - slideWidth) / 2;
                const slideOffset =
                  -(slideWidth * activeSlideIndex) -
                  this.params.spaceBetween * activeSlideIndex +
                  centerOffset;
                wrapper.style.transform = `translate3d(${slideOffset}px, 0px, 0px)`;

                if (this.activeIndex > this.previousIndex) {
                  Array.from(carousel).forEach((element) => {
                    element.classList.remove("carousel_change-postion_next");
                    element.classList.add("carousel_change-postion_prev");
                  });
                } else {
                  Array.from(carousel).forEach((element) => {
                    element.classList.add("carousel_change-postion_next-2");
                    element.classList.remove("carousel_change-postion_prev");
                  });
                }
              }
            } else {
              // Original desktop behavior
              if (this.activeIndex === 0) {
                Array.from(slide).forEach((element) => {
                  element.classList.remove("slide_change-postion");
                });
                Array.from(carousel).forEach((element) => {
                  element.classList.add("carousel_change-postion_next");
                  element.classList.remove("carousel_change-postion_prev");
                  element.classList.remove("carousel_change-postion_next-2");
                });
              } else {
                if (this.activeIndex > this.previousIndex) {
                  Array.from(carousel).forEach((element) => {
                    element.classList.remove("carousel_change-postion_next");
                    element.classList.remove("carousel_change-postion_next-2");
                    element.classList.add("carousel_change-postion_prev");
                  });
                  Array.from(slide).forEach((element) => {
                    if (buttonNext.hasClass("swiper-button-disabled")) {
                      element.classList.remove("slide_change-postion");
                    } else {
                      element.classList.add("slide_change-postion");
                    }
                  });
                } else {
                  Array.from(carousel).forEach((element) => {
                    element.classList.add("carousel_change-postion_next-2");
                    element.classList.remove("carousel_change-postion_prev");
                  });
                  Array.from(slide).forEach((element) => {
                    element.classList.remove("slide_change-postion");
                  });
                }
              }
            }
            this.update();
          },
        },
      };

      let swiperSlider = new Swiper(`#${id} .swiper-carousel`, {
        navigation: {
          nextEl: `#${id} .swiper-button-next__prod`,
          prevEl: `#${id} .swiper-button-prev__prod`,
        },
        ...prodSwiperParams,
      });
    });
  };

  // Rest of your code remains the same
  document.addEventListener("DOMContentLoaded", function () {
    prodcarousel();
  });
  document.addEventListener("shopify:section:load", function () {
    prodcarousel();
  });
  document.addEventListener("resize", function () {
    prodcarousel();
  });
  document.addEventListener("visibilitychange", function () {
    prodcarousel();
  });
  prodcarousel();
})();

//button-with-underline
if (window.screen.width > 990) {
  let attachedProductCarousel = false;

  let carouselSection = document.querySelector(".product-carousel-section");

  let imageContainerCarousel = carouselSection.querySelector(
    ".button--with-underline--container"
  );

  let followMouseCarousel = (event) => {
    if (imageContainerCarousel) {
      imageContainerCarousel.style.left = event.pageX + "px";
      imageContainerCarousel.style.top = event.pageY + 30 + "px";
    }
  };

  function showTextCarousel() {
    if (!attachedProductCarousel && imageContainerCarousel) {
      attachedProductCarousel = true;
      imageContainerCarousel.style.display = "block";
      document.addEventListener("pointermove", followMouseCarousel);
    }
  }

  function hideTextCarousel() {
    if (imageContainerCarousel) {
      attachedProductCarousel = false;
      imageContainerCarousel.style.display = "";
      document.removeEventListener("pointermove", followMouseCarousel);
    }
  }
}
